// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Configs
import servicesConfig from '../../config/services-config';

const servicesActionMiddleware = (store) => (next) => (action) => {
    const {dispatch, getState} = store;
    next(action);

    const nextState = getState();
    const actions = {
        SERVICES_ACTION_UPDATE_GH_IMAGES_GET: () => handleGrasshopperImagesUpdate(dispatch, nextState),
        SERVICES_ACTION_UPDATE_STB_ACTIONS: () => handleStbActions(dispatch, nextState),
        SERVICES_ACTION_UPDATE_PROPERTIES_ACTIONS: () => handlePropertiesActions(dispatch, nextState),
    };

    if (actions[action.type]) {
        return actions[action.type]();
    }
};

function handleGrasshopperImagesUpdate(dispatch, nextState) {
    const {data, multiRedux} = nextState.servicesActionData;

    const dispatchFetched = (res) => {
        dispatch({
            type: 'SERVICES_ACTION_UPDATE_GH_IMAGES_FULFILLED',
            response: res,
            multiRedux,
        });
    };

    const dispatchError = (error) => {
        dispatch({
            type: 'SERVICES_ACTION_UPDATE_GH_IMAGES_REJECTED',
            error,
            multiRedux,
        });
    };

    const actionParams = {
        servicesConfig: servicesConfig.grasshopperUpdateImages,
        dispatchUnauthenticated: true,
        noAuthenticationRequired: true,
        dispatchFetched,
        dispatchError,
    };

    dispatch({
        type: 'SERVICES_ACTION_UPDATE_GH_IMAGES',
    });

    return Promise.resolve(
        actionsServiceCaller(actionParams, {data: JSON.stringify(data)}, servicesConfig.grasshopperUpdateImages.path)
    );
}

function handleStbActions(dispatch, nextState) {
    const {data} = nextState.servicesActionData;

    const dispatchFetched = (res) => {
        let returnObject = {};
        switch (data.method) {
            case 'get':
                returnObject = {
                    type: 'SERVICES_ACTION_UPDATE_STB_ACTIONS_FULFILLED_GET',
                    responseGet: res,
                };
                break;
            case 'post':
                returnObject = {
                    type: 'SERVICES_ACTION_UPDATE_STB_ACTIONS_FULFILLED_POST',
                    responsePost: res,
                };
                break;
            case 'put':
                returnObject = {
                    type: 'SERVICES_ACTION_UPDATE_STB_ACTIONS_FULFILLED_PUT',
                    responsePut: res,
                };
                break;
            case 'delete':
                returnObject = {
                    type: 'SERVICES_ACTION_UPDATE_STB_ACTIONS_FULFILLED_DELETE',
                    responseDelete: res,
                };
                break;
        }

        dispatch(returnObject);
    };

    const dispatchError = (error) => {
        dispatch({
            type: 'SERVICES_ACTION_UPDATE_STB_ACTIONS_REJECTED',
            error,
        });
    };

    let servicesConfigCustom = {};
    switch (data.method) {
        case 'get':
            servicesConfigCustom = servicesConfig.stbActionsGet;
            break;
        case 'post':
            servicesConfigCustom = servicesConfig.stbActionsPost;
            break;
        case 'put':
            servicesConfigCustom = servicesConfig.stbActionsPut;
            break;
        case 'delete':
            servicesConfigCustom = servicesConfig.stbActionsDelete;
            break;
    }

    const actionParams = {
        servicesConfig: servicesConfigCustom,
        dispatchUnauthenticated: true,
        noAuthenticationRequired: true,
        dispatchFetched,
        dispatchError,
    };

    dispatch({
        type: 'SERVICES_ACTION_STB_ACTIONS',
    });

    return Promise.resolve(actionsServiceCaller(actionParams, {data: JSON.stringify(data)}, servicesConfigCustom.path));
}

function handlePropertiesActions(dispatch, nextState) {
    const {data} = nextState.servicesActionData;
    const dispatchFetched = (res) => {
        let returnObject = {};
        switch (data.method) {
            case 'get':
                returnObject = {
                    type: 'SERVICES_ACTION_UPDATE_PROPERTIES_ACTIONS_FULFILLED_GET',
                    responsePropertiesGet: res,
                };
                break;
            case 'put':
                returnObject = {
                    type: 'SERVICES_ACTION_UPDATE_PROPERTIES_ACTIONS_FULFILLED_PUT',
                    responsePropertiesPut: res,
                };
                break;
            case 'post':
                returnObject = {
                    type: 'SERVICES_ACTION_UPDATE_PROPERTIES_ACTIONS_FULFILLED_POST',
                    responsePropertiesPost: res,
                };
                break;
        }

        dispatch(returnObject);
    };

    const dispatchError = (error) => {
        dispatch({
            type: 'SERVICES_ACTION_UPDATE_PROPERTIES_ACTIONS_REJECTED',
            error,
        });
    };

    let servicesConfigCustom = {};
    switch (data.method) {
        case 'get':
            servicesConfigCustom = servicesConfig.propertiesGet;
            break;
        case 'put':
            servicesConfigCustom = servicesConfig.propertiesPut;
            break;
        case 'post':
            servicesConfigCustom = servicesConfig.propertiesPost;
            break;
    }

    const actionParams = {
        servicesConfig: servicesConfigCustom,
        dispatchUnauthenticated: true,
        noAuthenticationRequired: true,
        dispatchFetched,
        dispatchError,
    };

    dispatch({
        type: 'SERVICES_ACTION_PROPERTIES_ACTIONS',
    });

    return Promise.resolve(actionsServiceCaller(actionParams, {data: JSON.stringify(data)}, servicesConfigCustom.path));
}

export default servicesActionMiddleware;
